<template>
<div class='resources-carousel'>
  <h3
    v-if='show_headline'
    class='resources-carousel_headline body-one-light'
  >
    {{ $t('additional_resources') }}
  </h3>

  <div
    class='resources-carousel_container'
    :class='list_classes'
  >
    <button
      v-if='show_buttons'
      class='resource-carousel_prev'
      :disabled='disable_prev'
      @click.prevent='prev'
    />

    <div class='resources-carousel_list'>
      <div
        class='resources-carousel_list-inner'
        :style='list_shift'
      >
        <a
          v-for='(resource, index) in resources'
          :key='index'
          ref='resource'
          :href='linkHref(resource)'
          :target='linkTarget(resource)'
          class='resources-carousel_resource'
          @click='linkClick(resource, $event)'
        >
          <div
            class='resources-carousel_resource-image'
            :style="{backgroundImage: 'url(' + resource.carousel_image + ')'}"
          />

          <div class='resources-carousel_resource-headline copy-three'>
            {{ resource.headline }}
          </div>
        </a>
      </div>
    </div>

    <button
      v-if='show_buttons'
      class='resource-carousel_next'
      :disabled='disable_next'
      @click.prevent='next'
    />
  </div>
</div>
</template>

<script>
export default {
  props: [
    'resources',
    'show_headline',
    'pauseMedia',
    'context',
    'toggleActivityOverlay'
  ],

  data() {
    return {
      max_shown_items: 4,
      current_item: 0,
      option_width: null
    }
  },

  mounted() {
    this._recalculateWidth()

    $(window).on('resize', this._recalculateWidth)
    $(window).on('orientationchange', this._recalculateWidth)
  },

  beforeUnmount() {
    $(window).off('resize', this._recalculateWidth)
    $(window).off('orientationchange', this._recalculateWidth)
  },

  computed: {
    show_buttons() { return this.resources.length > this.max_shown_items },

    disable_prev() {
      return this.current_item === 0
    },

    disable_next() {
      return this.resources.length - this.current_item <= this.max_shown_items
    },

    list_shift() {
      const delta = (this.option_width + 10) * this.current_item

      return `transform: translateX(-${delta}px);`
    },

    list_classes() {
      const classes = []
      if (this.max_shown_items > this.resources.length) {
        classes.push('list-centered')
      }
      classes.push('list-max-' + this.max_shown_items)
      classes.push('list-length-' + this.resources.length)

      return classes
    }
  },

  methods: {
    prev() {
      this._calculateItemWidth()
      this.current_item--
    },

    next() {
      this._calculateItemWidth()
      this.current_item++
    },

    linkTarget(resource) {
      return this._isArticle(resource) || this._isAudio(resource) ? '' : '_blank'
    },

    linkHref(resource) {
      if (this._isArticle(resource)) {
        return '#article'
      } else {
        return this._isAudio(resource) ? '#audio' : resource.link.href
      }
    },

    linkClick(resource, event) {
      if (this._isArticle(resource)) {
        event.preventDefault()
        this.stopMedia()
        // this.toggleActivityOverlay({ article: resource })
        this.toggleActivityOverlay(resource)
      }

      if (this._isAudio(resource)) {
        event.preventDefault()
        this.stopMedia()
        // this.toggleActivityOverlay({ resource: resource })
        this.toggleActivityOverlay(resource)
      }

      const gtmEvent = {
        event:                (this.context === 'video' ? 'resourceClickVideo' : 'resourceClickCarousel'),
        pageCategory:         (this.context === 'video' ? 'video' : 'carousel'),
        resourceTitle:        resource.headline,
        resourceURL:          this.linkHref(resource),
        resourceDestination:  (this.linkHref(resource).search('article') >= 0 ? 'internal' : 'external')
      }

      dataLayer.push(gtmEvent)
    },

    stopMedia() {
      switch (this.context) {
        case 'video':
        case 'audio':
          this.pauseMedia()
          break
      }
    },

    _calculateItemWidth() {
      setTimeout(() => {
        this.option_width = $(this.$el).find('.resources-carousel_resource-image').first().outerWidth() + 10
      }, 1)
    },

    _recalculateWidth() {
      this.current_item = 0

      this._calculateItemWidth()

      if (window.innerWidth <= 768 && window.innerWidth > 480) {
        this.max_shown_items = 3
      } else if (window.innerWidth <= 480) {
        this.max_shown_items = 1
      } else {
        this.max_shown_items = 4
      }
    },

    _isArticle(resource) {
      return resource.type === 'activity_v1_articles'
    },

    _isAudio(resource) {
      return resource.type === 'activity_v1_audios'
    }
  }
}
</script>

<style lang='sass'>
@import './resources-carousel'
</style>
